export const DISPLAY_CONSTANTS = {
  APP_NAME: {
    WEB: $localize`Global Pickup and Delivery (GPD)`,
    MOBILE: $localize`GPD`,
  },
};
